import type { Supportes } from 'templates/pool/types';

function pickString(v: unknown): string | null {
  if (typeof v === 'string') {
    const t = v.trim();
    return t || null;
  }
  if (typeof v === 'number' && !Number.isNaN(v)) return String(v);
  return null;
}

function readNested(obj: Record<string, unknown> | undefined, keys: string[]): string | null {
  if (!obj) return null;
  for (const k of keys) {
    const s = pickString(obj[k]);
    if (s) return s;
  }
  return null;
}

export function readSupporterPaymentRaw(item: Supportes): string | null {
  const r = item as Supportes & Record<string, unknown>;

  const top = readNested(r, [
    'payment_method',
    'paymentMethod',
    'payment_type',
    'paymentType',
    'billing_type',
    'billingType',
    'forma_pagamento',
    'formaPagamento',
    'method',
  ]);
  if (top) return top;

  const tx = r.transaction;
  if (tx && typeof tx === 'object' && !Array.isArray(tx)) {
    const fromTx = readNested(tx as Record<string, unknown>, [
      'payment_method',
      'paymentMethod',
      'billing_type',
      'billingType',
      'type',
      'method',
    ]);
    if (fromTx) return fromTx;
  }

  const purchase = r.purchase;
  if (purchase && typeof purchase === 'object' && !Array.isArray(purchase)) {
    const fromPur = readNested(purchase as Record<string, unknown>, [
      'payment_method',
      'paymentMethod',
      'billing_type',
      'billingType',
      'method',
    ]);
    if (fromPur) return fromPur;
  }

  const payment = r.payment;
  if (payment && typeof payment === 'object' && !Array.isArray(payment)) {
    const p = payment as Record<string, unknown>;
    const fromPay = readNested(p, ['method', 'type', 'billing_type', 'billingType', 'payment_method', 'paymentMethod']);
    if (fromPay) return fromPay;
  }

  return null;
}

export function supporterPaymentViaLine(item: Supportes): string | null {
  const raw = readSupporterPaymentRaw(item);
  if (!raw) return null;
  const normalized = raw.trim().toLowerCase().replace(/-/g, '_');
  if (!normalized) return null;
  let label: string;
  if (normalized === 'credit_card') label = 'cartão de crédito';
  else if (normalized === 'pix') label = 'pix';
  else if (normalized === 'boleto') label = 'boleto';
  else label = raw.trim();
  return `Via: ${label}`;
}
